export class CompanyCollectiveInvoiceSetting {
	public id: number;
	public companyId: string;
	public isActive: boolean;
	public parentCharge: number;
	public subAgentCharge: number;
	public invoiceDayOfMonth: number;
	public customerEmail: string;
	public billingEmail: string;
	public billingEmailCc: string;
	public daysUntilDue: number;

	constructor(setting?: CompanyCollectiveInvoiceSetting) {
		Object.assign(this, setting);
	}
}
